import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream font-sans text-charcoal" data-id="element-0" data-mp="2wk0a329kipw1">
      <Hero data-id="element-1" data-mp="2wifgpfyzpczr" />
      <main data-id="element-2" data-mp="2whx9joashed2">
        <PainSection data-id="element-3" data-mp="2wi5l9cv6edmo" />
        <SolutionSection data-id="element-4" data-mp="28u5vaf5our95" />
        <VolumesSection data-id="element-5" data-mp="28te37ebavbnm" />
        <BonusesSection data-id="element-6" data-mp="28sl4n0mhvsgk" />
        <TestimonialsSection data-id="element-7" data-mp="23vcjcr61v8b3" />
        <OfferSection data-id="element-8" data-mp="23w4g45bdvc2y" />
        <GuaranteeSection data-id="element-9" data-mp="23ujho4ly78zt" />
        <FaqSection data-id="element-10" data-mp="23t8h0dnsuhcx" />
        <FinalCtaSection data-id="element-11" data-mp="3ik7gwiph6frp" />
      </main>
      <Footer data-id="element-12" data-mp="3ij652c0mxp8x" />
    </div>;
}